import { useRecurringExamEventCreation } from '@exam-center/exam-event-creation';
import { Navigate, useParams } from '@exam-center/router';
import { Outlet } from 'react-router-dom';

export default function recurringExamEventCreateReviewLayout() {
  const { examCenterCode, year, month } = useParams(
    '/:examCenterCode/exam-events/years/:year/months/:month/recurring-create/review',
  );
  const { examEvent } = useRecurringExamEventCreation();

  if (!examEvent) {
    return (
      <Navigate
        to='/:examCenterCode/exam-events/years/:year/months/:month/recurring-create'
        replace
        params={{ examCenterCode, year, month }}
      />
    );
  }
  return <Outlet />;
}
